/**
 * @package Ninja Forms builder
 * @subpackage Actions - New Action Drawer
 * @copyright (c) 2015 WP Ninjas
 * @since 3.0
 */
define( 'controllers/actions/newsletterList',[], function( ) {
    var controller = Marionette.Object.extend( {
        initialize: function() {
            this.listenTo( nfRadio.channel( 'setting-newsletter_list' ),             'show:setting',      this.defaultFields );
            this.listenTo( nfRadio.channel( 'setting-type-newsletter_list' ),        'click:extra',       this.clickListUpdate );
            this.listenTo( nfRadio.channel( 'actionSetting-newsletter_list' ),       'update:setting',    this.maybeRenderFields );
            this.listenTo( nfRadio.channel( 'actionSetting-newsletter_list' ),       'update:setting',    this.maybeRenderGroups );
            this.listenTo( nfRadio.channel( 'setting-name-newsletter_list_fields' ), 'init:settingModel', this.registerFieldsListener );
            this.listenTo( nfRadio.channel( 'setting-name-newsletter_list_groups' ), 'init:settingModel', this.registerGroupsListener );
        },

        defaultFields: function( settingModel, dataModel ) {
            this.maybeRenderFields( dataModel, settingModel );
            this.maybeRenderGroups( dataModel, settingModel );
        },

        registerFieldsListener: function ( model ) {
            model.listenTo( nfRadio.channel( 'newsletter_list_fields' ), 'update:fieldMapping', this.updateFieldMapping, model );
        },

        registerGroupsListener: function ( model ) {
            model.listenTo( nfRadio.channel( 'newsletter_list_groups' ), 'update:interestGroups', this.updateInterestGroups, model );
        },

        clickListUpdate: function( e, settingModel, dataModel, settingView ) {

            var data = {
                action: 'nf_' + dataModel.attributes.type + '_get_lists',
                security: nfAdmin.ajaxNonce
            };

            var that = this;

            /*
             * The spin animation is defined on `.dashicons.spin`, so the class
             * belongs on the icon itself rather than the link around it. The
             * original code reached for `e.srcElement`, which jQuery does not
             * provide, so the control never showed anything at all.
             */
            var icon = settingView.$el.find( '.js-newsletter-list-update .dashicons' ).first();

            /*
             * Clear any previous message and start the indicator now, so every
             * click visibly does something even when the outcome is the same
             * as last time.
             */
            this.clearListError( settingView );

            icon.addClass( 'spin' );

            this.inFlight = ( this.inFlight || 0 ) + 1;

            jQuery.post( ajaxurl, data, function( response ){

                var parsed;

                try {
                    parsed = JSON.parse( response );
                } catch ( error ) {
                    parsed = null;
                }

                if( ! parsed || ! parsed.lists || ! parsed.lists.length ) {

                    /*
                     * The lists could not be loaded. Say so, and leave the
                     * dropdown and the person's saved choice alone.
                     */
                    that.showListError( settingView, ( parsed && parsed.error ) ? parsed.error : that.defaultErrorMessage );
                    return;
                }

                that.clearListError( settingView );

                var selectedList = dataModel.get( 'newsletter_list' );
                var stillAvailable = _.find( parsed.lists, function( list ) {
                    return list.value == selectedList;
                });

                that.updateLists( settingModel, parsed.lists, settingView, dataModel );

                /*
                 * Keep the person's list selected when it is still there;
                 * only fall back to the placeholder when it is not.
                 */
                if( ! stillAvailable ) {
                    dataModel.set( 'newsletter_list', parsed.lists[0].value, { settingModel: settingModel } );
                }

            }).fail( function() {
                that.showListError( settingView, that.defaultErrorMessage );
            }).always( function() {

                that.inFlight = Math.max( 0, ( that.inFlight || 1 ) - 1 );

                // Only stop the indicator once nothing is still being fetched.
                if( ! that.inFlight ) icon.removeClass( 'spin' );
            });
        },

        defaultErrorMessage: 'Your lists could not be loaded. The connection to this service may need to be refreshed.',

        showListError: function( settingView, message ) {

            this.clearListError( settingView );

            var notice = jQuery( '<span class="nf-setting-error nf-newsletter-list-error"></span>' ).text( message );

            /*
             * Sits beside the refresh control, above the dropdown, matching
             * where the same message appears when the page renders it.
             */
            var icon = settingView.$el.find( '.js-newsletter-list-update' ).first();

            if( icon.length ) {
                icon.after( notice );
            } else {
                settingView.$el.find( 'label' ).first().prepend( notice );
            }
        },

        clearListError: function( settingView ) {
            settingView.$el.find( '.nf-newsletter-list-error' ).remove();
        },

        updateLists: function( settingModel, lists, settingView, dataModel ) {
            settingModel.set( 'options', lists );
            settingView.render();
        },

        maybeRenderFields: function( dataModel, settingModel ) {

            if( 'undefined' == typeof settingModel ) return;

            var selectedList = dataModel.get( 'newsletter_list' );
            var lists = settingModel.get( 'options' );
            _.each( lists, function( list ) {
                if ( selectedList == list.value ) {
                    nfRadio.channel( 'newsletter_list_fields').trigger( 'update:fieldMapping', list.fields );
                }
            } );

            dataModel.set( 'newsletter_list_fields', 0 );
        },

        maybeRenderGroups: function( dataModel, settingModel ) {
            if( 'undefined' == typeof settingModel ) return;

            var selectedList = dataModel.get( 'newsletter_list' );
            var lists = settingModel.get( 'options' );
            _.each( lists, function( list ) {
                if ( selectedList == list.value ) {
                    nfRadio.channel( 'newsletter_list_groups').trigger( 'update:interestGroups', list.groups );
                }
            } );

            dataModel.set( 'newsletter_list_fields', 0 );
        },

        updateFieldMapping: function( fields ) {
           var settings = this.get( 'settings' );
            settings.reset();
            _.each( fields, function( field ){

                settings.add({
                    name: field.value,
                    type: 'textbox',
                    label: field.label,
                    width: 'full',
                    use_merge_tags: { exclude: [ 'user', 'post', 'system', 'querystrings' ] }
                });
            });
            this.set( 'settings', settings );
        },

        updateInterestGroups: function( groups ) {
            var settings = this.get( 'settings' );
            settings.reset();
            _.each( groups, function( group ){

                settings.add({
                    name: group.value,
                    type: 'toggle',
                    label: group.label,
                    width: 'full',
                });
            });
            this.set( 'settings', settings );
        },

    });

    return controller;
} );

